export const MAP_CENTER = { lng: -2.479169, lat: 54.432394 } as const
export const MAP_ZOOM = 6 as const
